// @flow

import * as React from "react";

import s from "./PhoneNumber.scss";

type Props = {
  label: string | number,
  value: string | number,
  name: string | number,
  placeholder: string | number,
  onChange: (e: SyntheticEvent<any>) => void,
  disabled: boolean,
  hasError: boolean,
};

export const PhoneNumber = (props: Props) => {
  const { label, value, name, placeholder, onChange, disabled, hasError,
  } = props;

  const inputStyle = hasError ? [s.input, s.error] : [s.input];
  const prefilledStyle = hasError ? [s.prefilled_input, s.error_prefilled] : [s.prefilled_input];
  // clone and delete hasError b/c it is not a natural DOM input attribute
  const clonedProps = {...props};
  delete clonedProps.hasError;

  return (
    <label className={s.label}>
      {label}
      <div className={s.wrapper}>
        <input
          className={inputStyle.join(' ')}
          type={'text'}
          value={value}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
          {...clonedProps}
        />
         <input
          className={prefilledStyle.join(' ')}
          type={'text'}
          defaultValue={"+1"}
          readOnly
        />
      </div>
    </label>
  );
};

export default PhoneNumber;
